import type * as React from "react";
import type {Theme, Components} from "../..";
import {accordionClasses} from "../../../components/Accordion";

declare module "@mui/material/Accordion" {
    interface AccordionOwnerState {
        inverted?: boolean;
    }
}
type AccordionOverrides = Components<Theme>["MuiAccordion"];

const overrides: AccordionOverrides = {
    defaultProps: {
        disableGutters: true,
    },
    styleOverrides: {
        root: ({theme}) => ({
            backgroundColor: "transparent",
            boxShadow: theme.shadows[0],

            "&::before": {
                backgroundColor: theme.color.divider.default,
            },

            [`&.${accordionClasses.expanded}`]: {
                margin: 0,
                "&::before": {
                    opacity: 1,
                },
            },
        }),
    },
};

export default overrides;
